import { t } from "ttag";

import { REFERRAL_MIN_CREDIT_TO_USE } from "@/shared/domains/referral";
import { Alert, GiftIcon } from "@/shared/ui";

export const InsufficientCreditAlert = () => {
  return (
    <Alert icon={GiftIcon}>
      <h4>{t`You'll need $${REFERRAL_MIN_CREDIT_TO_USE} in credit to unlock savings. Invite friends and start earning today!`}</h4>
    </Alert>
  );
};
